import {observable, action, computed} from 'mobx'

export class IndicatorStore{
    @observable indicatorCounter = 0
    @action addIndicator(){
        this.indicatorCounter++
    }
    @action removeIndicator(){
        if(this.indicatorCounter > 0)
            this.indicatorCounter--
    }
    @computed get show(){
        return this.indicatorCounter > 0?true:false
    }
}
